var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RCard',[_c('div',{staticClass:"text-subtitle-1 text-secondary-2"},[_vm._v("Summary")]),_vm._t("content",function(){return [_c('div',{staticClass:"text-body-1 text-secondary-1 q-mt-md"},[_vm._v(_vm._s(_vm.data))])]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }